import { HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import {
  ReferralRequestBody,
  UsePromotionRequestBody,
  UsePromotionResponseModel,
  UserResponseModel,
} from 'models/user';
import { getLocalStorage } from 'utils/sessionStorage';

const userApi = {
  getUser: (): Promise<HttpResponse<UserResponseModel>> => {
    const url = '/terabet/api/user';
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  usePromotion: (
    request: UsePromotionRequestBody,
  ): Promise<HttpResponse<UsePromotionResponseModel>> => {
    const url = `/terabet/api/users/promotion/use`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  enableShareRanking: () => {
    const url = `/terabet/api/users/enable-ranking`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  changeWallet: (coinId: number) => {
    const url = `/terabet/api/users/base-wallet`;
    return handleRequest(
      axiosClient.post(
        url,
        { coinId },
        {
          headers: {
            Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
          },
        },
      ),
    );
  },
  updateReferralCode: (body: ReferralRequestBody) => {
    const url = `/terabet/api/users/referral-code`;
    return handleRequest(
      axiosClient.post(url, body, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  createVinpayAccount: () => {
    const url = `/terabet/api/users/vinpay/sync-user`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
};

export default userApi;
